import type { WebUserGetProfileExtraOutputDto } from '@bldsoft/ovp-api-types'
import type { UsersPreferences } from '@setplex/tria-api'

export const formatUsersPreferences = ({
  collections,
  regions,
}: WebUserGetProfileExtraOutputDto): UsersPreferences => ({
  collections: [...collections].map(({ id, title, contentCount }) => ({
    id,
    title,
    contentCount,
  })),
  regions: [...regions].map(
    ({
      id,
      name,
      liveCount,
      vodCount,
      alias,
      onboardingImage,
      isMultiFlagOnboardingImage,
      languageForOnboarding,
    }) => ({
      id,
      name,
      liveCount,
      vodCount,
      alias,
      onboardingImage,
      isMultiFlagOnboardingImage,
      languageForOnboarding: languageForOnboarding ?? undefined,
    })
  ),
})
